import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconTasks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTasks"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 9.5L16.5 9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M11.5 14.5L16.5 14.5" stroke="currentColor" strokeLinecap="square"/><Circle cx="8" cy="9.5" r="0.5" stroke="currentColor" strokeLinecap="square"/><Circle cx="8" cy="14.5" r="0.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTasks;
